import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import banktable2 from "assets/images/bankguarantee_table_2.svg";

import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";

function BillCollection() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`Bill for
              <span className="jumbotron-subtitle-2">
                Collection-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Bills for Collection-i is one of the trade services which refers
              to handling of documents by the Bank in accordance with
              instruction received, in order to:
            </p>
            <p>
              a. Obtain payment and/or acceptance; or<br></br>b. Deliver
              documents against payment and/or against acceptance; or
              <br></br>c. Deliver documents on other terms and conditions
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>
              Inward Bills for Collection-<i>i</i> (IBC-<i>i</i>)
            </h3>
          </div>
          <div className="col-xl-8">
            <p>
              An Inward Bill for Collection-i (IBC-i) is a trade service offered
              by the Bank as Collecting/ Presenting Bank to handle inward
              documents received from correspondent banks (foreign or domestic)
              for presentation to buyers to either:
            </p>
            <p>
              i. Obtain payment from drawee (sight Bills);<br></br>
              ii. Deliver commercial documents against drawee’s acceptance and
              to obtain payment on maturity of the Bills;<br></br>
              iii. Obtain drawee’s acceptance and deliver commercial documents
              against payment.
            </p>
            <p>
              The services are divided into 2 which are:<br></br>i. Domestic
              Inward Bills for Collection – <i>i&nbsp;</i> (DIBC –{" "}
              <i>i&nbsp;</i>); and
              <br></br> ii. Foreign Inward Bills for Collection (FIBC-
              <i>i&nbsp;</i>).
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>
              Shariah Contract (IBC-<i>i</i>)
            </h3>
          </div>
          <div className="col-xl-8">
            <p>
              IBC–<i>i&nbsp;</i>&nbsp;is structured under the concept of Wakalah
              bil Ujrah in which the Bank is nominated as an agent to act on
              behalf of customer (wakil) to perform delegated task with
              imposition of fee/s. Under IBC-<i>i&nbsp;</i>, the Bank will act
              as agent for the buyer/ importer to perform checking on collection
              instructions and documents received.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>
              Outward Bill for Collection-i (OBC-<i>i</i>)
            </h3>
          </div>
          <div className="col-xl-8">
            <p>
              An Outward Bill for Collection-<i>i&nbsp;</i> (OBC– <i>i&nbsp;</i>
              ) is a trade service offered by the Bank to handle for outward
              collection as instructed by the sellers for onward submission to
              the buyer either for:
            </p>
            <p>
              i. Against payment<br></br>The documents are released to the buyer
              only when the buyer pays the amount due.
            </p>
            <p>
              ii. Against acceptance<br></br>The documents are released to the
              buyer when the buyer accepts a bill of exchange for payment at a
              later date.{" "}
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>
              Shariah Contract (OBC-<i>i</i>)
            </h3>
          </div>
          <div className="col-xl-8">
            <p>
              OBC–<i>i&nbsp;</i> is structured under the concept of Wakalah bil
              Ujrah in which the Bank is nominated as an agent to act on behalf
              of customer (wakil) to perform delegated task with imposition of
              fee/s. Under OBC-<i>i&nbsp;</i>, the Bank will act as agent for
              the seller/ exporter to handle the processing of documents,
              collect payment from Collecting Bank on its behalf and any other
              task as delegated by the customer.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={banktable2}
              className="d-inline-block align-top"
              alt=""
            />

            <div className="link-button-row">
              <LinkButton
                text="Documentary Collection / Negotiation Form"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/tradefinancing/Documentary Collection_Negotiation Form.pdf`
                  )
                }
              />{" "}
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/tradefinancing/1680579344_Trade Finance Instruments - Fees and Charges.pdf`
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/business-financing/PDS+-+Bills+for+Collection.pdf`
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default BillCollection;
